/* ============================================================
   Home page — entry
   ------------------------------------------------------------
   Imports only the JS components this page's markup uses, mirrors
   assets/css/pages/home.css.
   ============================================================ */
import { initBusinessOutcomes } from "../component/business-outcomes-carousel.js";
import { initTechTabs } from "../component/tech-tabs.js";
import { initIndustriesAccordion } from "../component/industries-accordion.js";
import { initTestimonials } from "../component/testimonials-carousel.js";
import { initWhyCarousel } from "../component/why-carousel.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initAccordionGroups } from "../component/accordion.js";
import { initBlogSlider } from "../component/insights.js";
import { initFooterLanguage } from "../component/footer.js";
import { initGlowWrapper } from "../component/glow.js";
import {
  initCookieBar,
  initDmcabadge,
  initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
initContextMenu();
initDmcabadge();
initCookieBar();
initGooglePreferredSource();
initBusinessOutcomes();
initTechTabs();
initIndustriesAccordion();
initTestimonials();
initWhyCarousel();
initOfficeHoverReveal();
initAccordionGroups();
initBlogSlider();
initFooterLanguage();
initMobileMenu();

document.addEventListener("DOMContentLoaded", () => {
  initGlowWrapper();
});
